import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { SalesContext } from "../../context/salesContext";
import Sale from "./Sale";
import { Button, ConfirmDialog, DetailModal, EmptyState, Spinner } from "../ui";

const SalePage = () => {
    const { id } = useParams();
    const history = useHistory();
    const { action } = useContext(SalesContext);

    const [sale, setSale] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const loadSale = async () => {
        setLoading(true);
        try {
            const data = await action.getSale(id);
            setSale(data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadSale();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleConfirmDelete = async () => {
        setDeleting(true);
        try {
            await action.deleteSale(id);
            history.replace("/sales");
        } catch (err) {
            console.error("Error deleting sale:", err);
            setDeleting(false);
        }
    };

    if (loading) {
        return (
            <div className="flex h-[60vh] items-center justify-center">
                <Spinner size="lg" />
            </div>
        );
    }

    if (error || !sale) {
        return (
            <EmptyState
                icon={<i className="fas fa-shopping-cart" />}
                title="Sale not found"
                description="This sale may have been deleted or the link is incorrect."
                action={
                    <Button variant="secondary" onClick={() => history.push("/sales")}>
                        Back to sales
                    </Button>
                }
            />
        );
    }

    return (
        <div className="space-y-4">
            <Button
                variant="ghost"
                size="sm"
                onClick={() => history.push("/sales")}
                leadingIcon={<i className="fas fa-arrow-left" aria-hidden="true" />}
            >
                Back to sales
            </Button>

            <DetailModal
                mode="page"
                title="Sale Details"
                actions={
                    <div className="flex w-full justify-center">
                        <Button variant="danger" size="sm" onClick={() => setDeleteOpen(true)}>
                            Delete
                        </Button>
                    </div>
                }
            >
                <Sale selectedSale={sale} setSelectedSale={setSale} openSaleModal={loadSale} />
            </DetailModal>

            <ConfirmDialog
                open={deleteOpen}
                title="Delete this sale?"
                description="This action cannot be undone."
                confirmLabel="Delete sale"
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeleteOpen(false)}
                loading={deleting}
            />
        </div>
    );
};

export default SalePage;
